import { render, staticRenderFns } from "./tippingView.vue?vue&type=template&id=d4d5f1c0&"
import script from "./tippingView.vue?vue&type=script&lang=js&"
export * from "./tippingView.vue?vue&type=script&lang=js&"
import style0 from "./tippingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tippingView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VCard,
  VCheckbox,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileAction,
  VMenu,
  VSpacer,
  VTooltip,
})
